import {
    andThen,
    Decoder,
    fail,
    field,
    number,
    object,
    string,
    succeed
} from 'json-bouncer'

export interface OrderProtocolDetail {
    id: number
    orderProtocolId: number
    type: OrderProtocolDetailType
    value: string
}

export function orderProtocolDetailDecoder(): Decoder<OrderProtocolDetail> {
    return object({
        id: field('id', number()),
        orderProtocolId: field('orderProtocolId', number()),
        type: field('type', orderProtocolDetailTypeDecoder()),
        value: field('value', string()),
    })
}

export type OrderProtocolDetailType = 'To' | 'Cc'

export function orderProtocolDetailTypeDecoder(): Decoder<OrderProtocolDetailType> {
    return andThen(
        value => {
            switch (value) {
                case 'To':
                    const to: OrderProtocolDetailType = 'To'
                    return succeed(to)
                case 'Cc':
                    const cc: OrderProtocolDetailType = 'Cc'
                    return succeed(cc)
                default:
                    return fail('Invalid order protocol detail type')
            }
        },
        string())
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Entities/OrderProtocolDetail.ts